import React from 'react'
import { Helmet } from 'react-helmet-async'
import UserProfileLayout from '../../layouts/Profile/UserProfileLayout'

const UserProfilePage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Profile</title>
      <meta name="description" content="Profile page" />
    </Helmet>
    <UserProfileLayout />
  </React.Fragment>
)

export default UserProfilePage
